import React, { useEffect, useState } from 'react'
import { Container, Card, CardBody, Button, Input, Badge } from 'reactstrap'
import { Trash2, Search } from 'react-feather'
import { useDispatch } from 'react-redux'
import { useSnackbar } from 'notistack'
import PMBPagination from 'components/PMBPagination'
import LoadingAnimation from 'components/LoadingAnimation'
import BreadCrumbs from 'components/breadcrumbs'
import SvgIcon from 'components/Icon/SvgIcon'

const QRList = () => {
  const { enqueueSnackbar } = useSnackbar()
  const dispatch = useDispatch()

  const [search, setSearch] = useState('')
  const [currentPage, setCurrentPage] = useState(0)
  const [rowsPerPage, setRowsPerPage] = useState(10)
  const [isLoading, setIsLoading] = useState(false)

  // Simulasi data dari API
  const [data, setData] = useState({
    active: [],
    cleaned: [],
    totalItems: 0,
  })

  useEffect(() => {
    const fetchData = async () => {
      setIsLoading(true)
      // Simulasi delay fetch
      setTimeout(() => {
        const sampleData = {
          active: [
            {
              id: 'TUN0231',
              session: 'SES-20241106-1430',
              materials: 1,
              outputs: 1,
              lastUsed: '44 menit lalu',
            },
            {
              id: 'TUN0232',
              session: 'SES-20241106-1430',
              materials: 1,
              outputs: 0,
              lastUsed: '34 menit lalu',
            },
          ],
          cleaned: [
            {
              id: 'TUN0225',
              status: 'Dibersihkan',
              info: 'Siap digunakan kembali',
              lastUsed: '1 hari lalu',
            },
          ],
          totalItems: 3,
        }
        setData(sampleData)
        setIsLoading(false)
      }, 500)
    }

    fetchData()
  }, [currentPage, rowsPerPage])

  const handleClean = (carrierId) => {
    enqueueSnackbar(`Carrier ${carrierId} berhasil dibersihkan`, {
      variant: 'success',
    })
    setData((prev) => ({
      ...prev,
      active: prev.active.filter((x) => x.id !== carrierId),
      cleaned: [
        ...prev.cleaned,
        {
          id: carrierId,
          status: 'Dibersihkan',
          info: 'Siap digunakan kembali',
          lastUsed: 'Baru saja',
        },
      ],
    }))
  }

  const filteredActive = data.active.filter(
    (x) =>
      x.id.toLowerCase().includes(search.toLowerCase()) ||
      x.session.toLowerCase().includes(search.toLowerCase()),
  )

  const filteredCleaned = data.cleaned.filter((x) =>
    x.id.toLowerCase().includes(search.toLowerCase()),
  )

  return (
    <div className="pb-3 px-3 w-100">
      <Container className="custom-container">
        <h5 className="fw-bold mb-3">Pembersih QR</h5>
        <p className="text-muted mb-3">Kelola kode QR carrier</p>

        {/* Kolom Pencarian */}
        <div className="d-flex align-items-center mb-4 bg-light rounded px-2">
          <Search size={18} className="text-muted me-2" />
          <Input
            type="text"
            placeholder="Cari berdasarkan ID carrier atau sesi..."
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            className="border-0 bg-transparent"
            data-testid="process-qr-search-input"
          />
        </div>

        {isLoading ? (
          <LoadingAnimation />
        ) : (
          <>
            {/* Carrier Aktif */}
            <div className="mb-4">
              <div className="d-flex align-items-center mb-2">
                <SvgIcon size={30} id="qrcode" name="menu" color="#667085" />
                <h6 className="fw-semibold mb-0">Carrier Aktif</h6>
                <Badge
                  color="light"
                  className="ms-2 text-primary border border-primary"
                >
                  {filteredActive.length}
                </Badge>
              </div>

              {filteredActive.length === 0 ? (
                <div className="text-muted small">
                  Tidak ada carrier aktif yang ditemukan.
                </div>
              ) : (
                filteredActive.map((carrier) => (
                  <Card
                    key={carrier.id}
                    className="shadow-sm border-0 rounded-3 mb-2"
                    data-testid={`process-qr-card-${carrier.id}`}
                  >
                    <CardBody className="d-flex justify-content-between align-items-center py-3">
                      <div>
                        <div className="fw-semibold">{carrier.id}</div>
                        <div className="text-muted small">
                          {carrier.session}{' '}
                          <Badge color="primary" className="ms-1">
                            Aktif
                          </Badge>
                        </div>
                        <div className="small text-gray-600 mt-1">
                          Material: {carrier.materials} &nbsp; | &nbsp; Output:{' '}
                          {carrier.outputs}
                        </div>
                        <div className="small text-gray-500">
                          Terakhir digunakan {carrier.lastUsed}
                        </div>
                      </div>

                      <Button
                        color="light"
                        className="border text-danger"
                        onClick={() => handleClean(carrier.id)}
                        data-testid={`process-qr-clean-button-${carrier.id}`}
                      >
                        <Trash2 size={16} className="me-1" /> Bersihkan
                      </Button>
                    </CardBody>
                  </Card>
                ))
              )}
            </div>

            {/* Carrier yang Sudah Dibersihkan */}
            <div>
              <div className="d-flex align-items-center mb-2">
                <h6 className="fw-semibold mb-0">Carrier yang Dibersihkan</h6>
                <Badge
                  color="light"
                  className="ms-2 text-success border border-success"
                >
                  {filteredCleaned.length}
                </Badge>
              </div>

              {filteredCleaned.length === 0 ? (
                <div className="text-muted small">
                  Belum ada carrier yang dibersihkan.
                </div>
              ) : (
                filteredCleaned.map((carrier) => (
                  <Card
                    key={carrier.id}
                    className="shadow-sm border-0 rounded-3 mb-2"
                  >
                    <CardBody className="d-flex justify-content-between align-items-center py-3">
                      <div>
                        <div className="fw-semibold">{carrier.id}</div>
                        <div className="text-success small">{carrier.info}</div>
                        <div className="text-muted small">
                          {carrier.lastUsed}
                        </div>
                      </div>
                      <Badge color="success">Dibersihkan</Badge>
                    </CardBody>
                  </Card>
                ))
              )}
            </div>

            {/* Pagination */}
            <PMBPagination
              rowCount={data.totalItems}
              currentPage={currentPage}
              rowsPerPage={rowsPerPage}
              setCurrentPage={setCurrentPage}
              setRowsPerPage={setRowsPerPage}
              testId="process-qr-pagination"
            />
          </>
        )}
      </Container>
    </div>
  )
}

export default QRList
